module.exports = __webpack_public_path__ + "img/time.cb95eeb.svg";